exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'Roboto';\n  src: local(\"Roboto\"), local(\"Roboto-Regular\"), url(\"/static/fonts/Roboto-Regular.woff2\") format(\"woff2\"), url(\"/static/fonts/Roboto-Regular.woff\") format(\"woff\"), url(\"/static/fonts/Roboto-Regular.ttf\") format(\"truetype\"); }\n\n@font-face {\n  font-family: 'Lato';\n  src: local(\"Lato\"), local(\"Lato-Regular\"), url(\"/static/fonts/Lato-Regular.woff2\") format(\"woff2\"), url(\"/static/fonts/Lato-Regular.woff\") format(\"woff\"), url(\"/static/fonts/Lato-Regular.ttf\") format(\"truetype\"); }\n\n.emoji-attribution {\n  font-size: 16px;\n  font-family: 'Lato';\n  color: #0d47a1; }\n  .emoji-attribution a, .emoji-attribution a:visited, .emoji-attribution a:hover, .emoji-attribution a:active {\n    color: #0d47a1; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/app_footer/emoji_attribution/emoji_attribution.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/app_footer/emoji_attribution/emoji_attribution.scss
// module chunks = index